
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-tools/cli-reference",
      function () {
        return require("private-next-pages/developer-tools/cli-reference.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-tools/cli-reference"])
      });
    }
  